import { getBundleResources, mapActorResource } from "./fhir.utils";
import { ActorModel, DeviceResource, FhirClientPort } from "./fhir.types";

export class DeviceService {
  constructor(private readonly client: FhirClientPort) {}

  async searchByName(query: string): Promise<ActorModel[]> {
    const normalized = query.trim();
    const bundle = await this.client.search("Device", {
      ...(normalized ? { "device-name": normalized } : {}),
      status: "active",
      _count: 100,
    });

    return getBundleResources<DeviceResource>(bundle, "Device").map(
      mapActorResource,
    );
  }
}
